class MyRenaultResolver {
  constructor (Localization, UserService, VehicleService, IdsService, $log, $window, $location, StoreTypes, MyRenaultErrorCodes, MetricsService) {
    'ngInject'
    this.type = Localization.getLocalizedAppConfig().type
    this.errorUrl = Localization.getLocalizedAppConfig().errorUrl
    this.UserService = UserService
    this.VehicleService = VehicleService
    this.IdsService = IdsService
    this.$log = $log
    this.$window = $window
    this.$location = $location
    this.StoreTypes = StoreTypes
    this.myRenaultErrorCodes = MyRenaultErrorCodes
    this.metricsService = MetricsService
  }

  isMyRenault () {
    return this.type === this.StoreTypes.MYRENAULT ||
      this.type === this.StoreTypes.HELIOS ||
      this.type === this.StoreTypes.ONE
  }

  verifyToken (saveMetrics) {
    const token = (this.$location.search().token) ? this.$location.search().token : this.$window.localStorage.getItem('token')
    if (token) {
      if (saveMetrics) {
        this.metricsService.startPageLoadTime()
      }
      if (!this.$location.search().token) {
        this.$location.search('token', token)
      }
      const vinInToken = token.match(/<vin>(.+?)<\/vin>/)
      const vin = (vinInToken) ? vinInToken[1] : null
      const emailInToken = token.match(/<login_id>(.+?)<\/login_id>/)
      const email = (emailInToken) ? emailInToken[1] : null
      if (this.UserService.getCurrentToken()) {
        this.$log.debug('Token found in session storage')
        return this.UserService.getCurrentUser()
        .then((user) => {
          if (!(user && user.email)) {
            this.$log.warn('Current user not found, call login')
            return this.login(token, vin)
          } else {
            if (email === user.email) {
              this.$log.debug('Current user found, call verifyVin')
              return this.verifyVin(vin)
            } else {
              this.$log.debug('Current user doesn\'t match with helios token, call login')
              return this.login(token, vin)
            }
          }
        }, (err) => {
          this.$log.error('Error while retrieving current user, call login', err)
          return this.login(token, vin)
        })
      } else {
        this.$log.debug('Current token not found, call login')
        return this.login(token, vin)
      }
    } else {
      // Error 5
      this.$log.error('Token not found! Redirecting...')
      this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.TOKEN_NOT_PRESENT)
      return this.metricsService.endPageLoadTime(500).then(() => {
        return Promise.reject()
      })
    }
  }

  login (token, vin) {
    return this.UserService.login({token})
    .then(() => {
      this.$log.debug('Login OK, call synchronizeCurrentUserVehicles')
      return this.VehicleService.synchronizeCurrentUserVehicles()
        .then(() => {
          this.$log.debug('Vehicles synchronized from CSDB, call verifyVin')
          return this.verifyVin(vin)
        }, (err) => {
          this.$log.error('Vehicles not synchronized from CSDB, call verifyVin', err)
          return this.verifyVin(vin)
        })
    }, (err) => {
      // Error 1, 2, 3 or not treated
      this.$log.error('User authentication failed! Redirecting...', err)
      const errorCode = (err.data && err.data.meta && err.data.meta.code && this.myRenaultErrorCodes.hasOwnProperty(err.data.meta.code)) ? this.myRenaultErrorCodes[err.data.meta.code] : ''
      this.$window.top.location.href = this.errorPage(errorCode)
      return this.metricsService.endPageLoadTime(500).then(() => {
        return Promise.reject()
      })
    })
  }

  verifyVin (vin) {
    // Error 7, 8, 9
    if (vin === null) {
      this.$log.error('Vin is null! Redirecting...')
      this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.VIN_IS_NULL)
      return this.metricsService.endPageLoadTime(500).then(() => {
        return Promise.reject()
      })
    }
    if (!vin) {
      this.$log.error('Vin not present! Redirecting...')
      this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.VIN_NOT_PRESENT)
      return this.metricsService.endPageLoadTime(500).then(() => {
        return Promise.reject()
      })
    }
    return this.IdsService.encode(vin)
    .then((svin) => {
      this.$log.debug('Vin encoded, call getCurrentSelectedVehicle')
      this.svin = svin
      return this.VehicleService.getCurrentSelectedVehicle()
        .then((vehicle) => {
          if (vehicle && vehicle.vin === this.svin) {
            this.$log.debug('Current selected vehicle OK, return')
            return Promise.resolve()
          } else {
            this.$log.debug('Current selected vehicle NOK, switching vehicle')
            return this.VehicleService.setCurrentSelectedVehicle(this.svin)
          }
        })
        .catch((err) => {
          this.$log.warn('Unable to switch to vehicle, call synchronizeCurrentUserVehicles', err)
          return this.VehicleService.synchronizeCurrentUserVehicles()
            .then(() => {
              this.$log.debug('Vehicles synchronized from CSDB, call getCurrentUserVehicles')
              return this.VehicleService.getCurrentUserVehicles(false)
            }, (err) => {
              this.$log.warn('Vehicles not synchronized from CSDB, call getCurrentUserVehicles', err)
              return this.VehicleService.getCurrentUserVehicles(false)
            })
            .then(() => {
              this.$log.debug('Vehicles fetched, switching vehicle')
              return this.VehicleService.setCurrentSelectedVehicle(this.svin)
            })
            .catch((err) => {
              this.$log.error('Vin is not associated to email! Redirecting...', err)
              this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.VIN_EMAIL_ASSOCIATION)
              return this.metricsService.endPageLoadTime(500).then(() => {
                return Promise.reject()
              })
            })
        })
    }, (err) => {
      this.$log.error('Vin unknown! Redirecting...', err)
      this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.UNKNOWN_VIN)
      return this.metricsService.endPageLoadTime(500).then(() => {
        return Promise.reject()
      })
    })
  }

  errorPage (errorCode) {
    this.UserService.clearSession()
    return this.errorUrl + errorCode
  }
}

export default MyRenaultResolver



// WEBPACK FOOTER //
// ./src/app/common/my-renault/my-renault.resolver.js